import React, { useEffect, useState } from "react";
import { API } from "../../config/api.js";
import "bulma/css/bulma.css";
import "../../index.css"
import { Button, Col, Row } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import LoaderHome from "../Loader/LoaderHome.js"

import WellcomeCard from "../Admin/Components/Wellcome.js";
import TableNurse from "./Components/TableNurse";
import HeaderNurse from "./Components/HeaderNurse";
import FilterCard from "../Admin/Components/Filter.js";

import ModalDetailNurse from "./ModalNurseDetail/ModalDetail"
import HeaderApointmentNurse from "./Components/HeaderAppointmentNurse";
import SelectInputField from "../Global/SelectInputField.js";
import ModalDetailPatient from "./ModalNurseDetail/ModalPatientDetail"
import axios, { Axios } from "axios";
import Swal from "sweetalert2";

export default function Login() {
    document.title = "SDC Apps";
    const navigate = useNavigate();

    const level = localStorage.getItem('level');
    const rolesData = JSON.parse(localStorage.getItem('roles')) || [];
    const filteredRoles = rolesData.filter(role => role.name === 'Nurse');
    const filteredRolesAdmin = rolesData.filter(role => role.name === 'Admin');
    const filteredRolesANurse = rolesData.filter(role => role.name === 'Nurse');
    const levelUser = localStorage.getItem('level');


    const token = localStorage.getItem("token");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState();
    const [msg, setMsg] = useState("");
    const [rows, setRows] = useState(1);
    const [ascending] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    const [countAppointment, setCountAppointment] = useState(0);


    const [loading, setLoading] = useState(false);

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 980px)' })


    const [selectedMonth, setSelectedMonth] = useState(null);
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear.toString());

    const [getDetailDataNurse, setGetDetailDataNurse] = useState([]);
    const [getDetailDataNurseByAuth, setGetDetailDataNurseByAuth] = useState([]);

    const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);
    const [getDataNurseName, setGetDataNurseName] = useState([]);
    const [getData, setGetData] = useState([]);
    const [idDetailPatient, setIdDetailPatient] = useState();
    const [nikNurseSatuSehat, setNIKNurseSatuSehat] = useState();
    const [getDetailDataPatient, setGetDetailDataPatient] = useState([]);
    const [getDataTokenSatuSehat, setGetDataTokenSatuSehat] = useState([]);


    const [modalDetailDataNurse, setModalDetailNurse] = useState(false);
    const [modalDetaiDataPatient, setModalDetailPatient] = useState(false);
    const [modalDetailDataNurseSatuSehat, setModalDetailNurseSatuSehat] = useState(false);

    const [idDetailNurse, setIdDetailNurse] = useState();


    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };


    const GenerateTokenSatuSehat = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem('token');

            // change production
            const response = await axios.get(`http://192.168.200.194:5001/api/satu-sehat/generate-token`, {
                // const response = await axios.get(`http://192.168.200.194:5001/api/satu-sehat/generate-token`, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `${token}`,
                }
            });

            if (response?.status === 200) {
                setGetDataTokenSatuSehat(response.data);
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };

    useEffect(() => {
        if (getDataTokenSatuSehat.length === 0) {
            // GenerateTokenSatuSehat()
        }
    }, [getDataTokenSatuSehat])

    const GetResponseDataProfile = async () => {
        try {
            // e.preventDefault();
            setLoading(true)
            const response = await API.get(`user-service/auth/profile`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetDataProfileDetail(response.data.data.user_detail)
                // setLoading(false)
            }
        } catch (error) {
            swal({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }

    const GetResponseData = async () => {
        try {
            // e.preventDefault();
            setLoading(true)
            const response = await API.get(`user-service/nurse-users?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${keyword}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetData(response.data.data)
                setPage(response.data.pagination.current_page);
                setPages(response.data.pagination.total_pages);
                setRows(response.data.pagination.total);
                // setLoading(false)
            }
        } catch (error) {
            if (error.response.status === 401) {
                navigate('/dashboard')
                swal({
                    title: 'Failed',
                    text: `Akses dibatasi Tidak Dapat Mengakses Halaman Ini`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        }
    }

    const GetResponseDetailNurse = async () => {
        try {
            // e.preventDefault();
            setLoading(true)
            const response = await API.get(`user-service/Nurse-users/${idDetailNurse}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetDetailDataNurse(response?.data?.data)
                // setLoading(false)
            }
        } catch (error) {
            // setLoading(false)
            swal({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }

    const GetResponseDetailNurseByAuth = async () => {
        try {
            setLoading(true)
            // e.preventDefault();
            const monthParam = selectedMonth ? `&month=${selectedMonth}` : "";
            const yearParam = selectedYear ? `&year=${selectedYear}` : "";


            const response = await API.get(
                `transaction-service/appointments/Nurse/${localStorage.getItem('id_admin')}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}${monthParam}${yearParam}`,
                fetchParams)
            // Checking process
            if (response?.status === 200) {
                const data = response.data.data || [];
                setGetDetailDataNurseByAuth(data)
                setCountAppointment(response.data.countAppointment || 0);
                if (data.length > 0) {
                    setGetDataNurseName(data[0]?.Nurse_name);
                }
                setPage(response.data.pagination.current_page);
                setPages(response.data.pagination.total_pages);
                setRows(response.data.pagination.total);
            } else {
                throw new Error('Appointments data failed');
            }
        } catch (error) {

            const message = error?.response?.data?.message || error.message;
            if (message === "Appointment not found") {
                setGetDetailDataNurseByAuth([])
                setCountAppointment(0);
                setGetDataNurseName("");
            }

            if (error.response.status === 401) {
                navigate('/dashboard')
                swal({
                    title: 'Failed',
                    text: `Akses dibatasi Tidak Dapat Mengakses Halaman Ini`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        }
    }

    const GetResponseDetailPatient = async () => {
        try {
            // e.preventDefault();
            setLoading(true)
            const response = await API.get(`transaction-service/patients/${idDetailPatient}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetDetailDataPatient(response?.data?.data)
            }
        } catch (error) {
            swal({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }

    const GetAllData = async () => {
        try {
            setLoading(true);

            const promises = [];

            promises.push(GetResponseData());
            promises.push(GetResponseDataProfile());

            if (idDetailNurse) {
                promises.push(GetResponseDetailNurse());
            } else {

                if (filteredRoles.some(role => role.name === 'Nurse')) {
                    promises.push(GetResponseDetailNurseByAuth());
                }
            }

            await Promise.all(promises);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    const changePage = ({ selected }) => {
        setPage(selected + 1);
        if (selected === 10) {
            setMsg(
                ""
            );
        } else {
            setMsg("");
        }
    };

    const handleReset = () => {
        setSelectedMonth(null);
        setSelectedYear(currentYear.toString());
        setPage(1);
    };

    useEffect(() => {
        if (limit !== 10) {
            setPage(1);
        }
        GetAllData();
    }, [page, limit, idDetailNurse, selectedMonth, selectedYear]);

    useEffect(() => {
        const fetchDetail = async () => {
            setLoading(true);
            await GetResponseDetailPatient();
            setLoading(false);
        };

        if (modalDetaiDataPatient && idDetailPatient) {
            fetchDetail();
        }
    }, [modalDetaiDataPatient, idDetailPatient]);


    const buttonRefresh = () => {
        window.location.reload();
    };

    const modalDetailNurse = (id) => {
        setModalDetailNurse(true)
        setIdDetailNurse(id)
    }


    const monthList = [
        { label: "Pilih Bulan", value: "" },
        ...Array.from({ length: 12 }, (_, i) => {
            const month = (i + 1).toString().padStart(2, "0");
            const monthName = [
                "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                "Juli", "Agustus", "September", "Oktober", "November", "Desember"
            ][i];
            return { label: monthName, value: month };
        })
    ];


    const yearList = Array.from({ length: 6 }, (_, i) => {
        const year = 2020 + i;
        return { label: year.toString(), value: year.toString() };
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "month") setSelectedMonth(value);
        if (name === "year") setSelectedYear(value);
    };

    function formatToRupiah(angka) {
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
        });

        // Format angka ke format mata uang Rupiah
        const formattedString = formatter.format(angka);

        // Menghilangkan simbol "RP" (simbol mata uang) dari hasil format
        const rupiahWithoutSymbol = formattedString.replace('Rp', '');

        return rupiahWithoutSymbol.trim(); // Menghilangkan spasi yang mungkin ada
    }

    const modalDetailPatient = (id) => {
        setIdDetailPatient(id);
        setModalDetailPatient(true);
    };

    const modalDetailNurseSatuSehat = (id) => {
        setNIKNurseSatuSehat(id);
        setModalDetailNurseSatuSehat(true);
    };


    return (
        <>
            {level === 'developer' ? (
                <>
                    <Row>
                        <WellcomeCard
                            getDataProfileNull={getDataProfileDetail === null}
                            getDataProfileFirstName={getDataProfileDetail?.firstname}
                            getDataProfileLastName={getDataProfileDetail?.lastname}
                        />
                    </Row>

                </>
            ) : (
                <>
                    <FilterCard className="w-100 m-0 d-flex justify-content-center align-items-center">
                        <Row className="w-100 m-0">
                            <Col md={4}>
                                {/* <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>Total Pendapatan</span>
                                    <span style={{ fontSize: "20px", color: "#001F8B" }}>
                                        Rp. {formatToRupiah(getDetailDataNurseByAuth[0]?.total_price) ?? 0}
                                    </span>
                                </div> */}
                            </Col>
                            <Col md={8}>
                                <Row className="d-flex justify-content-center">
                                    <Col md={6}>
                                        <SelectInputField
                                            label="Tahun"
                                            name="year"
                                            value={selectedYear}
                                            onChange={handleChange}
                                            options={yearList}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <SelectInputField
                                            label="Bulan"
                                            name="month"
                                            value={selectedMonth}
                                            onChange={handleChange}
                                            options={monthList}
                                            disabled={!selectedYear}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </FilterCard>
                </>
            )
            }

            <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
                {modalDetailDataNurse && <ModalDetailNurse GetResponseData={GetResponseDetailNurse} getDetailDataNurse={getDetailDataNurse} idDetailNurse={idDetailNurse} show={modalDetailDataNurse} onHide={() => setModalDetailNurse(false)} />}
                {modalDetaiDataPatient && <ModalDetailPatient GetResponseData={GetResponseDetailPatient} getDetailDataPatient={getDetailDataPatient} idDetailPatient={idDetailPatient} show={modalDetaiDataPatient} onHide={() => setModalDetailPatient(false)} />}

                {loading && <LoaderHome />}
                {isTabletOrMobile ?
                    <>
                        {/* start header */}
                        <HeaderNurse
                            isTabletOrMobile={isTabletOrMobile}
                            query={query}
                            setQuery={setQuery}
                            limit={limit}
                            setLimit={setLimit}
                            buttonRefresh={buttonRefresh}
                            searchData={searchData}
                            showCustomButtonRelationPatient={false}
                        />

                        {/* end` header */}

                        <Col xl='12' sm='12'>
                            <div>
                                {/* start table */}
                                <TableNurse
                                    getData={getData}
                                    rows={rows}
                                    page={page}
                                    pages={pages}
                                    changePage={changePage}
                                    msg={msg}
                                    modalDetailNurse={modalDetailNurse}
                                    modalDetailNurseSatuSehat={modalDetailNurseSatuSehat}
                                    level={level}
                                    isTabletOrMobile={false}
                                />
                                {/* end table */}
                            </div>
                        </Col>
                    </>
                    :
                    <>
                        {level === 'developer' ? (
                            <>
                                {/* start header */}
                                <HeaderNurse
                                    isTabletOrMobile={isTabletOrMobile}
                                    query={query}
                                    setQuery={setQuery}
                                    limit={limit}
                                    setLimit={setLimit}
                                    buttonRefresh={buttonRefresh}
                                    searchData={searchData}
                                    showCustomButtonRelationPatient={false}
                                />
                                {/* end` header */}
                            </>
                        ) : (
                            <>
                                {/* start header */}
                                <HeaderApointmentNurse
                                    isTabletOrMobile={isTabletOrMobile}
                                    query={query}
                                    countAppointment={countAppointment}
                                    handleReset={handleReset}
                                    setQuery={setQuery}
                                    limit={limit}
                                    setLimit={setLimit}
                                    setPage={setPage}
                                    buttonRefresh={buttonRefresh}
                                    searchData={searchData}
                                    getDataNurseName={getDataNurseName}
                                    showCustomButtonRelationPatient={false}
                                />
                                {/* end` header */}
                            </>
                        )}

                        <Col xl='12' sm='12'>
                            <>
                                {/* start table */}
                                <TableNurse
                                    getData={getData}
                                    getDetailDataNurseByAuth={getDetailDataNurseByAuth}
                                    modalDetailPatient={modalDetailPatient}
                                    rows={rows}
                                    page={page}
                                    pages={pages}
                                    changePage={changePage}
                                    msg={msg}
                                    modalDetailNurse={modalDetailNurse}
                                    modalDetailNurseSatuSehat={modalDetailNurseSatuSehat}
                                    level={level}
                                    isTabletOrMobile={false}

                                />
                                {/* end table */}
                            </>
                        </Col>
                    </>
                }
            </div>
        </>
    );
}
